export const TRANSCRIPTION_LANGUAGES = [
  { key: 'en-US', value: 'English (US)' },
  { key: 'en-GB', value: 'English (UK)' },
  { key: 'en-AU', value: 'English (Australia)' },
  { key: 'en-IN', value: 'English (India)' },
  { key: 'en-IE', value: 'English (Ireland)' },
  { key: 'en-WL', value: 'English (Wales)' },
  { key: 'en-AB', value: 'English (Scotland)' },
  { key: 'en-NZ', value: 'English (New Zealand)' },
  { key: 'en-ZA', value: 'English (South Africa)' },
  { key: 'de-DE', value: 'German' },
  { key: 'fr-CA', value: 'French (Canada)' },
  { key: 'fr-FR', value: 'French (France)' },
  { key: 'it-IT', value: 'Italian' },
  { key: 'pt-BR', value: 'Portuguese (Brazil)' },
  { key: 'es-US', value: 'Spanish (US)' },
];

export const DEFAULT_TRANSCRIPTION_LANGUAGE = 'en-US';
